function getStopStartLine(name, xData, runStopData) {
  let lineColor = "rgba(93, 129, 155, .5)";
  let color = "#A6CAFF";

  let yData = [[], [], [], []]; //停，启，无数据,背景板条
  runStopData.forEach((i, index) => {
    yData[3][index] = 1;
    if (i > 0) {
      yData[0][index] = 1;
      yData[1][index] = 1;
      yData[1][index + 1] = 1;
      yData[2][index] = 0;
    } else if (i === 0) {
      yData[0][index] = 1;
      yData[1][index] = 0;
      yData[2][index] = 0;
    } else if (i === undefined || i === null) {
      yData[0][index] = 0;
      yData[1][index] = 0;
      yData[2][index] = 1;
    }
  });

  let sData = [];
  yData.forEach((arr) => {
    //let arr2 = Array.isArray(arr) ? arr : arr.data
    sData.push(
      arr.map((i, index) => {
        return i > 0 ? 1 : "underfind";
      })
    );
  });

  let optionBar = {
    title: {
      text: name,
      textStyle: {
        color: "#9bbff1",
        fontSize: 18,
      },
      padding: [20, 0, 0, 0],
    },
    tooltip: {
      trigger: "axis",
      formatter(params) {
        let str = "";
        str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
        if (params[2].data === 1) {
          //无数据 (启 会被暂无数据遮住)
          str += `<div>时间：${params[2].axisValue}</div>`;
          str += `<div>启停信号：${params[2].seriesName}</div>`;
        } else if (params[0].data === 1) {
          //开
          str += `<div>时间：${params[0].axisValue}</div>`;
          str += `<div>启停信号：${params[0].seriesName}</div>`;
        } else {
          //停
          str += `<div>时间：${params[1].axisValue}</div>`;
          str += `<div>启停信号：${params[1].seriesName}</div>`;
        }
        str += `</div>`;
        //		params.forEach((item,i)=>{
        //			if()
        //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
        //		})
        return str;
      },
    },
    legend: {
      selectedMode: false, //取消图例上的点击事件
      right: "0%",
      textStyle: {
        color: "#A6CAFF",
        fontSize: 16,
      },
      data: [
        {
          name: "启",
          icon: "image://data:image/jpg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAPAB4DASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAcJ/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AvQE6Z+AAP//Z",
        },
        {
          name: "停",
          icon: "image://data:image/jpg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAPAB4DASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAf/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCfAXBLwAH/2Q==",
        },
        {
          name: "无数据",
          icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAALElEQVRIS2OcMHXxf4YBAIyjFtMr1EeDml4hzTAa1KNBTbMQGE1cNAtadIMBXbkpuQbNYVgAAAAASUVORK5CYII=",
        },
      ],
    },
    grid: {
      left: "35",
      right: "60",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        padding: [0, 0, 0, 0],
        color,
        fontSize: 18, //bar字体设置
        align: "left",
      },
      data: xData,
    },
    yAxis: {
      type: "value",
      data: [0, 1],
      axisTick: {
        show: false,
      },
      max: 2,
      min: 0,
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        show: false,
        //    	inside: true,
        color,
        fontSize: 18, //bar字体设置
      },
      splitLine: {
        show: false,
      },
      boundaryGap: 0,
    },
    series: [
      {
        zlevel: 3,
        z: 3,
        data: sData[1],
        type: "line",
        //    name:params.name || "",
        name: "启",
        //    itemStyle: params.itemStyle || itemStyle[params.themeName] || getItemStyle()
        lineStyle: {
          color: "#0FE569",
          width: 30,
        },
        symbol: "none",
        itemStyle: {
          color: "#0FE569",
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#0FE569",
              },
              {
                offset: 1,
                color: "#0FE569",
              },
            ]),
          },
        },
      },
      {
        zlevel: 2,
        z: 2,
        name: "停",
        barCategoryGap: -1,
        data: sData[0],
        symbol: "none",
        type: "line",
        //			itemStyle:itemStyle[params.themeName]
        lineStyle: {
          width: 30,
          color: "#4A7BBF",
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#4A7BBF",
              },
              {
                offset: 1,
                color: "#4A7BBF",
              },
            ]),
          },
        },
      },
      {
        zlevel: 4,
        z: 4,
        data: sData[2],
        type: "line",
        symbol: "none",
        name: "无数据",
        lineStyle: {
          width: 30,
          color: "grey",
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "grey",
              },
              {
                offset: 1,
                color: "grey",
              },
            ]),
          },
        },
      },
      {
        zlevel: 1,
        z: 1,
        data: sData[3],
        type: "line",
        symbol: "none",
        name: "无数据",
        lineStyle: {
          width: 30,
          color: "grey",
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "grey",
              },
              {
                offset: 1,
                color: "grey",
              },
            ]),
          },
        },
      },
    ],
  };
  return optionBar;
}

export default getStopStartLine;
